import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import cn from 'classname';
import axios from 'axios';

import endpoints from '../../config/endpoints';

import forEach from 'lodash/forEach';

import Modal from './modal';
import Textarea from './form-elements/textarea';

lessRequire('modules/shared/complaint-form.less');

export default class Form extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			affiliate_id: props.user && props.user.general && props.user.general.id,
			email: props.user && props.user.general && props.user.general.email,
			isModalOpen: false
		};
		this.toggleModal = this.toggleModal.bind(this);
		this.submitForm = this.submitForm.bind(this);
	}

	toggleModal(e) {
		e && e.preventDefault();
		this.setState(prevState => ({
			...prevState,
			isModalOpen: !prevState.isModalOpen
		}));
	}

	submitForm(data) {
		return axios({
			url: `${endpoints.TICKETS.ALL}/quality`,
			method: 'post',
			data: { text: data.text ? data.text.trim() : '', email: this.state.email, affiliate_id: this.state.affiliate_id }
		})
			.then(() => this.toggleModal())
			.catch(err => {
				if (err.response.status === 400) {
					const errors = err.response.data;
					throw new SubmissionError(prepareFormErrors(errors));
				} else {
					this.toggleModal();
				}
			});
	}

	render() {
		return (
			<ComplaintFormPopup
				isModalOpen={this.state.isModalOpen}
				toggleModal={this.toggleModal}
				initialValues={{ text: null }}
				submitForm={this.submitForm}
				{...this.props}
			/>
		);
	}
}

Form.propTypes = {
	user: PropTypes.object,
	intl: PropTypes.func
};

const ComplaintFormPopup = props => (
	<div>
		<Modal
			isOpen={props.isModalOpen}
			onClose={props.toggleModal}
			title={props.intl('Оставить отзыв')}
			className={cn({
				ReactModal__Content: true,
				'ReactModal__Content--after-open': true,
				'modal-overlay__content': true,
				'complaint-form-popup': true
			})}
		>
			<ComplaintForm {...props} />
		</Modal>
	</div>
);

ComplaintFormPopup.propTypes = {
	isModalOpen: PropTypes.bool,
	toggleModal: PropTypes.func,
	intl: PropTypes.func
};

const ComplaintForm = reduxForm({ form: 'managerComplaintForm' })(props => (
	<div className="complaint-form">
		<form action="#" onSubmit={props.handleSubmit(props.submitForm)}>
			<Field name="text" placeholder={props.intl('Ваш отзыв')} autoFocus={true} component={Textarea} />
			<button type="submit" className="button yellow-btn font-proxima-nova-semibold">
				{props.intl('Отправить')}
			</button>
		</form>
	</div>
));

ComplaintForm.propTypes = {
	isModalOpen: PropTypes.bool,
	submitForm: PropTypes.func,
	intl: PropTypes.func
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	forEach(errors, value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	});
	return validationsErrors;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/complaint-form.js